/* globals $ */
import Component from './component';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {
    url: window.pko.url.main,
    toExclude: 'main, footer',
};

export default class FullPageLoader extends Component {
  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;
    this.$body = $('body');

    this.init();
  }

  init() {
    if (this.$context.length) {
      this.eventLoadOnPosition();
    }
  }

  eventLoadOnPosition() {
    $(window).on('scroll', () => {
      this.isTriggerApproaching();
      if (this.$body.hasClass('page-loaded')) {
        this.isRemoveArticlePossible();
      }
    });
  }

  isTriggerApproaching() {
    const scroll = window.pageYOffset;
    const wHeight = window.innerHeight;

    if (scroll + wHeight > this.$context.offset().top + (this.$context.height() / 2) && !this.$body.hasClass('page-loading-triggered')) {
      this.$body.addClass('page-loading-triggered');

      this.getPage().then(() => {
        this.$body.addClass('page-loaded');
      });
    }
  }

  isRemoveArticlePossible() {
    const scroll = window.pageYOffset;

    if (scroll >= $('main.cloned').offset().top - 100 && !this.$body.hasClass('page-article-removed')) {
      this.clearPage();
    }
  }

  clearPage() {
    window.scroll(0, 0);
    this.$body.addClass('page-article-removed').children('main, footer').not('.cloned').hide();
    window.history.pushState('', '', this.settings.url);
  }

  getPage() {
    this.$container = $('<div class="loading-element free-space"></div>');
    this.$body.append(this.$container);

    return $.get(this.settings.url + '?full=1', null, 'text')
      .then((re) => {
        this.$body.append(this.parseResult(re)).children('.loading-element').remove();
      })
      .done(() => this.fire('success'))
      .fail(() => () => {
        this.$container.remove();
        this.fire('error');
      })
      .always(() => this.fire('afterLoad'));
  }

  parseResult(inputHtml) {
    let html = $.parseHTML(inputHtml);
    let result = [];

    html.forEach((element) => {
      if ($(element).is(this.settings.toExclude)) {
        result.push($(element).addClass('cloned'));
      }
    });

    return result;
  }

  static initialize(selector = '.js-trigger-loading', ClassName = FullPageLoader, ClassNameString = 'FullPageLoader', $context = $(document.body), options = {}) {
    return super.initialize(selector, ClassName, ClassNameString, $context, options);
  }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/full-page-loader.js